import { Services } from "../../services/Services.js";
import { Control } from "../Control.js";
import { resolveValue } from "../utils/ui-helpers.js";

export class Field extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            label = 'Field',
            control = [],
        } = options;

        this.label = label;
        this.control = control;

    }

    getLabel() { return resolveValue(this.label) };

    getControl() { return resolveValue(this.control) };

    render(vm) {

        const ct = Services.get('templates');

        const label = this.getLabel() ?? 'Field';
        const css = this.getCss() ?? '';
        const control = this.getControl();

        return ct.field(css, [
            ct.label(label),
            control.render(vm),
        ])


    }

}